<sb-dashboard-widget
  [title]="'My timesheets' | translate"
  [isLoading]="isLoading()"
  [isEmpty]="timesheets().length === 0"
  [emptySettings]="{
    icon: 'stopwatch-cute-re',
    description: 'No hours yet - once added, they\'ll show up here.' | translate,
    buttonLabel: 'Add Worked Hours' | translate,
  }"
  (emptyAction)="openTimesheetModal()"
>
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    [label]="'Last' | translate"
    (modelChange)="onPeriodChange($event)"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-20">{{ 'Date' | translate }}</th>
        <th class="row-30">{{ 'Location' | translate }}</th>
        <th class="row-20">{{ 'Time' | translate }}</th>
        <th class="row-15">{{ 'Totals' | translate }}</th>
        <th class="row-15 text-center">{{ 'Status' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (timeSheet of timesheets(); track timeSheet.id) {
        <tr>
          <td>{{ timeSheet.date | localeDate: 'medium' }}</td>
          <td>{{ timeSheet.location_name }} - {{ timeSheet.department_name }}</td>
          <td>{{ timeSheet.starttime | time }} - {{ timeSheet.endtime | time }}</td>
          <td>{{ timeSheet.total | localeDuration: 'digital' }}</td>
          <td class="text-center">
            <sb-icon [name]="iconMapper[timeSheet.status]" size="xl" />
          </td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
